import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PHONE = '+33674626368';
const WHATSAPP_URL = 'https://wa.me/33674626368?text=Bonjour%2C%20je%20souhaite%20r%C3%A9server%20un%20taxi%20Yellow%20Cab%20Corsica.';

const CTABanner = () => {
  const { t } = useTranslation();
  return (
  <section className="bg-[#EAB308] py-16 px-4" data-testid="cta-banner">
    <div className="max-w-4xl mx-auto text-center">
      <img src="/yellowcab-logo-dark.png" alt="Yellow Cab Corsica" className="h-16 w-16 object-contain mx-auto mb-5 opacity-80" />
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-black mb-4 tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
        {t('cta.title')}
      </h2>
      <p className="text-black/65 text-base mb-8 max-w-xl mx-auto">{t('cta.subtitle')}</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a href={`tel:${PHONE}`} data-testid="cta-call-btn"
          className="inline-flex items-center justify-center gap-3 bg-black hover:bg-[#111] text-white font-bold px-10 py-4 rounded-full text-lg transition-colors duration-300 shadow-lg">
          <Phone size={20} />{t('cta.call')} — +33 6 74 62 63 68
        </a>
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp-btn"
          className="inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold px-10 py-4 rounded-full text-lg transition-colors duration-300 shadow-lg">
          <MessageCircle size={20} />{t('cta.whatsapp')}
        </a>
      </div>
    </div>
  </section>
  );
};

export default CTABanner;
